.backdrop {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--tuna-palette-backdrop);
  z-index: var(--tuna-zIndex-modal);
  -webkit-tap-highlight-color: transparent;
}
